import styled from "styled-components"

// Text sizes are in rem, to allow for larger base font on mobile devices
// without endless media queries. Conversion chart below for reference
// Default base font size is 14px. Mobile device base font size is 16px.

// Desktop    Rem value     Mobile
//---------------------------------
// 12 px      0.86rem       ~14px
// 13 px      0.92rem       ~15px
// 14 px      1rem          16px
// 16 px      1.14rem       ~18px
// 18 px      1.25rem       ~20px
// 20 px      1.43rem       ~22px
// 22 px      1.57rem       ~24px

/*
 * COMMERCE TEXT STYLES
 */

export const ProductTitle = styled.h2<{ $maxLines?: number }>`
  font-size: 1.14rem;
  font-weight: 600;
  font-family: ${(props) => props.theme.font.primary};
  color: ${(props) => props.theme.text.dark};
  margin: 5px 0;
  max-width: 100%;
  word-wrap: normal;
  text-align: left;

  // specifies max number of lines, to truncate with ellipsis
  -webkit-line-clamp: ${(props) =>
    props.$maxLines ? props.$maxLines : 5};
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;

  // because we set overflow to hidden, descenders can get cut off if line height isn't above 1.
  line-height: 1.1;
`

export const DiscountText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.text.discount};
  font-size: 1.14rem;
  span {
    color: ${(props) => props.theme.text.discount};
  }
`

export const ErrorText = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${(props) => props.theme.colors.error};
  font-size: 1.14rem;
`

// These styles match the Legend, but different semantic HTML
export const SectionHeading = styled.h2`
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1.14rem;
  color: ${(props) => props.theme.text.default};
  margin-bottom: 10px;
  margin-top: 0;
  font-weight: normal;
`

// An explanatory sentence / subtitle
export const SubHeading = styled.p`
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1rem;
  color: ${(props) => props.theme.colors.darkMed};
  margin: 5px 2px 15px;
`

export const ErrorHeading = styled.p`
  font-size: 1.14rem;
  font-weight: 600;
  color: ${(props) => props.theme.text.default};
  font-family: ${(props) => props.theme.font.primary};
  line-height: 1.3;
`

export const OriginalPrice = styled.span`
  color: ${(props) => props.theme.text.discount};
  span {
    color: ${(props) => props.theme.text.discount};
  }
  text-decoration: line-through;
  font-size: 1.2rem;
`
